<template>
  <div class="agreement agreementPage">
    <div class="title">响锣店群商户注册及服务协议</div>
      <div class="content">
        <div class="wel">
          <div class="joins">欢迎您使用响锣店群商户服务（以下简称“服务”）。</div>
          <div class="joins">提示：在您使用响锣店群服务之前，您应当认真阅读并遵守《响锣店群商户注册及服务协议》（以下简称“本协议”）以及《响锣店群服务隐私政策条款》。</div>
          <div
            class="joins"
          >本协议是由您在湖南响锣科技有限公司开发并运营的响锣店群平台（包括响锣店群网站，PC端、移动端的各种软件及应用程序，响锣店群硬件设备，以下均简称：“响锣店群”)上签署。双方就使用响锣店群服务相关事宜达成共识，请您务必审慎阅读、充分理解各条款内容。</div>
          <div class="name">
            <div class="num">一、协议内容及确认</div>
            <div
              class="things"
            >本协议内容包括本协议正文及所有响锣店群已经发布或将来可能发布及修改的各项政策、规则、声明、通知、警示、提示、说明等（以下简称“规则”）。前述规则为本协议不可分割的组成部分，与协议正文具有同等法律效力。</div>
            <div class="things">当您按照注册页面提示填写信息、上传资质信息等完成全部注册流程后，即表示您已充分阅读、理解并接受本协议的全部内容，本协议即产生法律效力。</div>
            <div
              class="things"
            >响锣店群平台（包括和与合作第三方一起）向您提供的服务，当您在相关页面上点击确认的时候，例如，您点击“开通服务”或类似文字的按钮，或者您已经实际使用该服务时，您点击确认或实际使用服务即代表您接受协议的内容。</div>
            <div
              class="things"
            >根据国家法律法规变化及网站运营需要，响锣店群有权根据需要不时制订、修改本协议及相关规则，变更后的协议和规则一经公布，立即取代原协议及规则并自动生效。您可以在响锣店群平台随时查阅最新协议。如您不同意相关变更，应当立即停止使用服务，如您继续使用服务或在响锣店群平台进行任何操作活动，即表示您已接受经修订的协议和规则</div>
            <div
              class="things"
            >如果您在任何时候对任何内容存在疑虑或异议，请您立即联系响锣店群（联系电话0731-84490799），以便对相关内容进行解释和说明，使您能够充分理解，从而帮助您决定是否接受服务规则及使用响锣店群的服务。</div>
          </div>
          <div class="name">
            <div class="num">二、服务内容</div>
            <div
              class="things"
            >1、响锣店群提供多平台的产品形态，包括但不限于手机客户端（iOS及Android版本）（具体以响锣店群平台最终提供的为准），电脑软件，智能硬件等。如您已注册使用一种产品形式的服务，则可以以同一账号使用其他版本服务，本协议自动适用于您对所有版本的软件和服务的使用。</div>
            <div
              class="things"
            >2、本服务内容范围包括但不限于门店移动支付服务、门店营销服务、互联网金融服务、供应链服务等一系列技术服务范畴。这些功能服务会根据用户需求的变化，服务范围的扩展，服务提供方（合作伙伴均为持牌的合法合规的支付机构、金融机构等）的要求或行业规定变化而被优化或修改，或因定期、不定期的维护而暂缓提供。</div>
            <div
              class="things"
            >3、同时，响锣店群保留在任何时候自行决定对服务或服务任何部分及其相关功能、应用软件变更、升级、修改、转移的权利。您同意针对上述行为，响锣店群均不需通知，并且对您和任何第三人不承担任何责任，但如果该变化或功能直接影响您的实际权益，响锣店群需要得到您的确认（通过响锣店群平台进行人工操作，点击确认）。</div>
            <div class="things">4、本协议项下的各项服务（包括未来将推出的服务）将由响锣店群及其关联公司自行或根据第三方合作方的授权分别或共同提供，或由第三方合作方提供。</div>
          </div>
          <div class="name">
            <div class="num">三、注册及账号管理</div>
            <div
              class="things"
            >1、您确认，在您完成注册程序或以其他响锣店群允许的方式实际使用服务时，您应当是具备完全民事权利能力和与所从事的民事行为相适应的行为能力的自然人、法人或其他组织。若您不具备前述主体资格，请勿使用服务，否则您及您的监护人应承担因此而导致的一切后果，且响锣店群有权注销（永久冻结）您在响锣店群平台的账户，若产生损失有权向您及您的监护人索偿。如您代表一家公司或其他法律主体进行注册或以其他响锣店群允许的方式实际使用本服务，则您声明和保证，您有权代表该公司或法律主体，该公司或该法律主体按照本协议约定执行。</div>
            <div
              class="things"
            >2、本服务需要您以实名进行登记。您注册时应提交真实、准确、完整和反映当前情况的身份及其他相关信息，包括但不限于营业执照、负责人身份证等，并根据业务需要在该等文件上加盖公章。</div>
            <div
              class="things"
            >3、响锣店群有权也有义务向支付机构合作方提供您的上述材料和信息，材料以及信息的最终判断由支付机构合作方确认。响锣店群或支付机构合作方为您提供回访服务或进行终端相关业务检查时，您应积极配合响锣店群和支付机构合作方的相关人员工作，支付机构合作方有权审查您提交的资质证明材料，如经审查，支付机构合作方认为您不具备或部分不具备申请资质，支付机构合作方有权通过响锣店群提示拒绝向您提供服务。</div>
            <div
              class="things"
            >4、您对所提供材料和信息的准确性、完整性、合法性和真实性承担责任。在任何信息发生变更时，立即书面通知响锣店群。您在注册材料中填写的通讯地址和方式为双方同意，任何书面通知发往以上地址，均视为已送达。</div>
            <div
              class="things"
            >5、您理解并同意，您可以使用您提供或确认的手机号或者响锣店群允许的其它方式作为账号进行注册，并且您承诺注册的账号名称、设置的号、头像和简介等信息中不得出现违法和不良信息，不得冒充他人，不得未经许可为他人注册，不得以可能导致其他用户误认的方式注册账号或设置号，不得使用可能侵犯他人权益的用户名（包括但不限于涉嫌商标权、名誉权侵权等），否则响锣店群有权不予注册或停止服务并收回平台账号，因此产生的损失由您自行承担。</div>
            <div
              class="things"
            >6、您了解并同意，您在响锣店群平台注册的账号所有权归属于响锣店群，注册完成后，您仅获得账号使用权。账号使用权仅归属于初始申请注册人，不得以任何方式转让或供给非您门店经营相关的他人使用，否则，响锣店群有权立即不经通知收回该账号，由此带来的因您使用本服务产生的全部数据、信息等被清空、丢失等的损失，您应自行承担。</div>
            <div
              class="things"
            >7、在您成功注册后，响锣店群将根据账号和密码确认您的身份。您应妥善保管您的终端设备及账户和密码，并对利用该账户和密码所进行的一切活动（包括但不限于网上点击同意，提交各类业务操作，购买服务等）负全部责任。您承诺，在密码或账户遭到未获授权的使用，或者发生其他任何安全问题时，将立即通知响锣店群，且您同意并确认，响锣店群不对上述情形产生的任何直接或间接的遗失或损害承担责任。除非有法律规定或司法裁定，且征得响锣店群的同意，否则，您的账户、密码不得以任何方式转让、赠与或继承（与账户相关的财产权益除外）。</div>
            <div class="things">8、响锣店群根据本协议收回或取消账号后，有权自行对账号相关内容及信息以包括但不限于删除等方式进行处理，且无需就此向用户承担任何责任。</div>
          </div>
          <div class="name">
            <div class="num">四、服务使用规范</div>
            <div class="things">1、您承诺，使用响锣店群服务时，您将严格遵守本协议所列明的各项规则及规范要求。</div>
            <div
              class="things"
            >2、您充分了解并同意，响锣店群仅为您提供服务平台，您应自行对利用服务从事的所有行为及结果承担责任。相应地，您应了解，使用服务可能发生来自他人非法或不当行为（或信息）的风险，您应自行判断及行动，并自行承担相应的风险。</div>
            <div class="things">3、您承诺不会利用本服务进行任何违法或不当的活动，包括但不限于下列行为:</div>
            <div
              class="things"
            >3.1 上载、传送或分享含有下列内容之一的信息： (a) 反对法律规定； (b) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的； (c) 损害国家荣誉和利益的； (d) 煽动民族仇恨、民族歧视、破坏民族团结的； (e) 破坏国家宗教政策，宣扬邪教和封建迷信的； (f) 散布谣言，扰乱社会秩序，破坏社会稳定的； (g) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的； (h) 侮辱或者诽谤他人，侵害他人合法权利的； (i) 含有虚假、诈骗、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容； (j) 含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的</div>
            <div class="things">3.2 冒充任何人或机构，或以虚伪不实的方式陈述或谎称与任何人或机构有关；</div>
            <div class="things">3.3 伪造标题或以其他方式操控识别资料，使人误认为该内容为响锣店群或其关联公司所传送；</div>
            <div
              class="things"
            >3.4 将依据任何法律或合约或法定关系（例如由于雇佣关系和依据保密合约所得知或揭露之内部资料、专属及机密资料）知悉但无权传送之任何内容加以上载、传送或分享；</div>
            <div class="things">3.5 将涉嫌侵害他人权利（包括但不限于著作权、专利权、商标权、商业秘密等知识产权）之内容上载、传送或分享；</div>
            <div
              class="things"
            >3.6 跟踪或以其它方式骚扰他人,或通过本服务向好友或其他用户发送大量信息；进行任何超出正常的好友或用户之间内部或外部信息沟通、交流等目的的行为；</div>
            <div
              class="things"
            >3.7 将任何广告、推广信息、促销资料、垃圾邮件、滥发信件、连锁信件、直销或其它任何形式的劝诱资料加以上载、传送或分享；供前述目的使用的专用区域或专用功能除外；</div>
            <div
              class="things"
            >3.8 从事任何违反中国法律、法规、规章、政策、规范性文件以及支付机构规定的行为，例如信用卡及第三方机构提供的信用额度套现交易、他人支付账号的盗刷交易、为获得支付机构的补贴而进行的无正常交易实质的交易等。</div>
            <div class="things">4、您承诺不对本软件和服务从事以下行为：</div>
            <div
              class="things"
            >4.1 将有关干扰、破坏或限制任何计算机软件、硬件或通讯设备功能的软件病毒或其他计算机代码、档案和程序之资料，加以上载、张贴、发送电子邮件或以其他方式传送；</div>
            <div class="things">4.2 干扰或破坏本服务或与本服务相连线之服务器和网络，或违反任何关于本服务连线网络之规定、程序、政策或规范；</div>
            <div
              class="things"
            >4.3 通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；</div>
            <div class="things">4.4 自行、授权他人或利用第三方软件对本软件及其组件、模块、数据等进行干扰，反向工程。</div>
            <div class="things">5、您应自行承担因使用服务所产生的费用，包括但不限于上网流量费、通信服务费等。</div>
            <div
              class="things"
            >6、您同意并接受响锣店群了解您上载、传送或分享的资料及信息，但响锣店群有权对您使用服务的情况进行审查、监督并采取相应行动，包括但不限于删除信息、中止或终止服务，及向有关机关报告。</div>
            <div class="things">7、您承诺不以任何形式使用本服务侵犯响锣店群的商业利益，或从事任何可能对响锣店群造成损害或不利于响锣店群的行为。</div>
            <div
              class="things"
            >8、您了解并同意，在响锣店群服务提供过程中，响锣店群及其关联公司或其授权单位和个人有权以各种方式投放各种商业性广告或其他任何类型的推广信息，同时，您同意接受以电子邮件、短信或其他方式向您发送的上述广告或推广信息。</div>
            <div
              class="things"
            >9、您可以在响锣店群平台上根据实际需求添加门店、终端、管理员、收银员，但您对上述添加行为以及之后的操作行为承担责任，如果由于您添加上述账号从而导致损失，由您自行承担或赔偿。</div>
            <div
              class="things"
            >10、您充分了解并同意，您必须为自己注册帐号下的一切行为负责，包括您所发表的任何内容以及由此产生的任何后果。您应对使用本服务时接触到的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。响锣店群无法且不会对您因前述风险而导致的任何损失或损害承担责任。</div>
            <div
              class="things"
            >11、如果响锣店群发现或收到他人举报您有违反本协议约定的，响锣店群有权不经通知随时对相关内容进行删除、屏蔽，并采取包括但不限于收回账号，冻结账户资金，限制、暂停、终止您使用部分或全部本服务，追究法律责任等措施。</div>
            <div
              class="things"
            >12、如您使用服务平台发布的信息内容违法违规，响锣店群有权视情采取警示、限制功能、暂停更新、关闭账号等处置措施，保存记录并向有关主管部门报告。</div>
          </div>
          <div class="name">
            <div class="num">五、服务费用</div>
            <div
              class="things"
            >1、商户注册成功后，响锣店群将收取商户因使用相关服务而发生的服务费。因服务的任何免费试用或免费功能和服务不应视为响锣店群放弃后续收费的权利。响锣店群有权以书面形式通知您收费标准，若您继续使用则表述您接受响锣店群的服务，需按响锣店群公布的收费标准支付费用</div>
            <div class="things">2、不同服务的费用以各服务的具体条款确定，包括具体支付方式等。</div>
            <div
              class="things"
            >3、响锣店群有权根据实际情况提前单方面调整服务费用标准及收费方式，并以公告形式通知您，而无需获得您的事先同意，如您不同意收费应当立即停止服务的使用，否则使用则视为您已同意并应当缴纳费用。</div>
          </div>
          <div class="name">
            <div class="num">六、门店移动支付服务</div>
            <div class="things">
              1、您注册响锣店群平台表明您同意通过响锣店群平台向支付机构申请接入并使用包括但不限于以下服务（合称“支付服务”）
              银联银行卡刷卡支付和闪付、银联云闪付、微信支付、支付宝支付、京东钱包、百度钱包、QQ钱包、和包支付、沃支付、翼支付、各商业银行扫码支付等
            </div>
            <div
              class="things"
            >2、根据您的申请，响锣店群将根据支付服务所对应的支付机构合作方的要求对您的资质进行审查，是否开通上述支付解决服务以及开通哪些支付服务，以支付机构合作方的最终审查为准。</div>
            <div class="things">3、您无论使用以上任一或全部服务，均应遵守本协议项下的各项约定，以及所有适用法律法规和监管部门、结算机构、支付机构合作方的规定和要求。</div>
          </div>
          <div class="name">
            <div class="num">七、特别授权</div>
            <div
              class="things"
            >一旦您违反本协议，或与响锣店群及响锣店群合作伙伴（共同合作为您提供服务）签订的其他协议的约定，响锣店群有权以任何方式通知响锣店群关联公司及响锣店群合作伙伴，要求其对您的权益采取限制措施，包括但不限于要求响锣店群关联公司、合作伙伴中止、终止对您提供部分或全部服务，且在其经营或实际控制的任何网站公示您的违约情况。</div>
            <div class="things">响锣店群有权根据您上述违约行为的影响等来决定部分或全部服务恢复的时间。</div>
          </div>
          <div class="name">
            <div class="num">八、第三方应用</div>
            <div
              class="things"
            >1、响锣店群允许第三方应用接入服务平台，您可以在响锣店群直接获得各种第三方应用服务。您了解并同意，响锣店群仅作为平台提供者，相关应用由该第三方独立提供，响锣店群不对您对该应用的使用承担任何责任。</div>
            <div class="things">2、您了解并同意，如响锣店群对服务或其部分做出调整、中止或终止而对第三方应用服务产生影响，响锣店群不承担任何责任。</div>
            <div class="things">3、您通过第三方应用或服务使用时，响锣店群可能会调用第三方系统或者通过第三方支持您的使用或访问，使用或访问的结果由该第三方提供。</div>
            <div class="things">4、第三方应用也可以通过调用响锣店群提供的接口获得您在响锣店群平台的信息，但必须得到您的授权同意。</div>
          </div>
          <div class="name">
            <div class="num">九、服务中止或终止</div>
            <div
              class="things"
            >1、您同意，鉴于互联网服务的特殊性，响锣店群有权随时中止、终止或致使中止终止服务或其任何部分；对于免费服务发生中止或终止的情形，响锣店群无需向您发出通知。</div>
            <div
              class="things"
            >2、您了解并同意，响锣店群可能定期或不定期地对提供网络服务的平台设备、设施和软硬件进行维护或检修，如因此类情况而造成收费服务在合理时间内中止，响锣店群无需承担责任，但应尽可能事先进行通告。</div>
            <div class="things">3、您通过第三方应用或服务使用时，响锣店群可能会调用第三方系统或者通过第三方支持您的使用或访问，使用或访问的结果由该第三方提供。</div>
            <div class="things">3.1 用户违反本协议约定的注册义务和使用规范；</div>
            <div class="things">3.2 用户使用收费服务时未按规定支付相应服务费；</div>
          </div>
          <div class="name">
            <div class="num">十、隐私政策</div>
            <div class="things">1、您在服务注册的账户具有密码保护功能，以确保您基本信息资料的安全，请您妥善保管账户及密码信息</div>
            <div
              class="things"
            >2、响锣店群勤勉尽职地采取各种合理的物理、电子和管理方面的安全措施来保护您的信息，使您存储在中的信息和通信内容不会被泄漏、毁损或者丢失。响锣店群会按现有技术提供相应的安全措施来保护您的信息，提供合理的安全保障，响锣店群将在任何时候尽力做到使您的信息不被泄漏、毁损或丢失，但同时也请您注意在信息网络上不存在绝对完善的安全措施，请妥善保管好相关信息。</div>
            <div
              class="things"
            >3、响锣店群有权根据法律规定和业务情况决定您在本软件及服务中数据的最长储存期限、服务器中数据的最大存储空间等，您应当保管好终端、账号及密码，并妥善保管相关信息和内容，响锣店群对您自身原因导致的数据丢失或被盗以及在本软件及服务中相关数据的删除或储存失败不承担责任。</div>
            <div
              class="things"
            >4、响锣店群将依法保障您在使用本服务过程中的知情权和选择权，如为提供服务之目的而需要开启收集地理位置、读取通讯录、使用摄像头、启用录音等功能，将向您明示并取得您的同意。</div>
            <div class="things">5、其他隐私条款见《响锣店群服务隐私政策条款》。</div>
          </div>
          <div class="name">
            <div class="num">十一、知识产权</div>
            <div
              class="things"
            >1、您了解及同意，除非响锣店群另行声明，本协议项下服务包含的所有产品、技术、软件、程序、数据及其他信息（包括但不限于文字、图像、图片、照片、音频、视频、图表、色彩、版面设计、电子文档）的所有知识产权（包括但不限于版权、商标权、专利权、商业秘密等）及相关权利均归响锣店群或其关联公司所有。</div>
            <div
              class="things"
            >2、您应保证，除非取得响锣店群书面授权，对于上述权利您不得（并不得允许任何第三人）实施包括但不限于出租、出借、出售、散布、复制、修改、转载、汇编、发表、出版、还原工程、反向汇编、反向编译，或以其它方式发现原始码等的行为。</div>
            <div
              class="things"
            >3、服务涉及的Logo（包括但不限于“响锣店群”）等文字、图形及其组成，以及响锣店群其他标识、徵记、产品和服务名称均为响锣店群及其关联公司在中国和其它国家的商标，用户未经响锣店群书面授权不得以任何方式展示、使用或作其他处理，也不得向他人表明您有权展示、使用、或作其他处理。</div>
            <div class="things">4、您理解并同意授权响锣店群在宣传和推广中使用您的名称、商标、标识，但仅限于表明您属于我们的客户或合作伙伴。</div>
          </div>
          <div class="name">
            <div class="num">十二、责任承担</div>
            <div
              class="things"
            >1、服务将按"现状"和按"可得到"的状态提供。响锣店群在此明确声明对服务不作任何明示或暗示的保证，包括但不限于对服务的可适用性，没有错误或疏漏，持续性，准确性，可靠性，适用于某一特定用途之类的保证，声明或承诺。</div>
            <div class="things">2、响锣店群对服务所涉的技术和信息的有效性，准确性，正确性，可靠性，质量，稳定，完整和及时性均不作承诺和保证。</div>
            <div
              class="things"
            >3、响锣店群系统在下列状况发生时会无法正常运作，所以下列情形中响锣店群无法向您提供服务。您对此充分理解并同意响锣店群无须就下述情况所导致服务无法正常提供时给您造成的各种影响或损失承担责任：</div>
            <div class="things">3.1 我们公告的系统停机维护期间。</div>
            <div class="things">3.2 电信设备出现故障不能进行数据传输的。</div>
            <div class="things">3.3 发生台风、地震、海啸、洪水、停电、战争、恐怖袭击等事件造成我们系统障碍不能执行业务的。</div>
            <div class="things">3.4 由于黑客攻击、电信部门技术调整或故障、网站升级、第三方方面的问题等原因而造成我们的服务中断或者延迟。</div>
            <div
              class="things"
            >4、不论是否可以预见，不论是源于何种形式的行为，响锣店群不对由以下原因造成的任何特别的，直接的，间接的，惩罚性的，突发性的或有因果关系的损害或其他任何损害（包括但不限于利润或利息的损失，营业中止，资料灭失）承担责任。</div>
            <div class="things">4.1 使用或不能使用服务；</div>
            <div class="things">4.2 通过服务购买或获取任何产品，样品，数据，信息或进行交易等，或其他可替代上述行为的行为而产生的费用；</div>
            <div class="things">4.3 未经授权的存取或修改数据或数据的传输；</div>
            <div class="things">4.4 第三方通过服务所作的陈述或行为</div>
            <div class="things">4.5 其它与服务相关事件，包括疏忽等，所造成的损害。</div>
            <div
              class="things"
            >5、您充分了解并同意，鉴于互联网体制及环境的特殊性，您在服务中分享的信息及个人资料有可能会被他人复制、转载、擅改或做其它非法用途；您在此已充分意识此类风险的存在，并确认此等风险应完全由您自行承担，响锣店群对此不承担任何责任。</div>
            <div
              class="things"
            >6、您了解并同意，在使用服务过程中可能存在来自任何他人的包括威胁性的、诽谤性的、令人反感的或非法的内容或行为或对他人权利的侵犯（包括知识产权）及匿名或冒名的信息的风险，基于服务使用规范所述，该等风险应由您自行承担，响锣店群对此不承担任何责任。</div>
          </div>
          <div class="name">
            <div class="num">十三、个人信息授权</div>
            <div
              class="things"
            >您同意授权响锣店群，基于信息备份、运营需要或经有权部门要求等目的，有权通过您以及您曾经或正在使用的第三方收银服务机构以及其他第三方数据机构等对您的个人基本信息、财务信息，服务信息等数据或信息进行核实，有权通过您或前述第三方收银机构采集您的个人基本信息、财务信息、交易信息等信息，您同意授权响锣店群通过第三方收银服务机构采集相关信息。</div>
            <div
              class="things"
            >您同意授权响锣店群向第三方服务机构提供您的个人基本信息、财务信息，服务信息等以判断、识别业务风险及提升自身服务质量；且您同意第三方服务机构依据法律法规就授权范围内对上述信息进行采集、获取、存储、处理、提供、传输、披露。您同意授权响锣店群有权从第三方收银服务机构采集商户的个人基本信息，财务信息，交易信息等信息。</div>
          </div>
          <div class="name">
            <div class="num">十四、违约责任及赔偿</div>
            <div
              class="things"
            >1、如果响锣店群发现或收到他人举报您有违反本协议约定的，经核实后响锣店群有权不经通知随时对相关内容进行删除、屏蔽，并采取包括但不限于限制、暂停、终止您使用账号及服务，限制、暂停、终止您使用部分或全部本服务，追究法律责任等措施。</div>
            <div
              class="things"
            >2、您同意，由于您通过服务上载、传送或分享之信息、使用本服务其他功能、违反本协议、或您侵害他人任何权利因而衍生或导致任何第三人向响锣店群及其关联公司提出任何索赔或请求，或响锣店群及其关联公司因此而发生任何损失，您同意将足额进行赔偿（包括但不限于合理律师费）。</div>
          </div>
          <div class="name">
            <div class="num">十五、有效通知</div>
            <div
              class="things"
            >1、响锣店群向您发出的任何通知，可采用电子邮件、页面公开区域公告、个人网络区域提示、手机短信或常规信件等方式，且该等通知应自发送之日视为已向用户送达或生效。</div>
            <div
              class="things"
            >2、您同意，您向响锣店群发出的任何通知应发至响锣店群对外正式公布告知用户的电子邮件、通信地址、传真号码等联系信息，或使用其他响锣店群认可的其他通知方式进行送达。</div>
          </div>
          <div class="name">
            <div class="num">十六、争议解决及其他</div>
            <div
              class="things"
            >1、本协议之解释与适用，以及与本协议有关的争议，均应依照中华人民共和国法律予以处理。双方因本协议发生纠纷，应本着友好协商的原则商议解决，若协商不成，任何一方均有权提交上海仲裁委员会进行仲裁。除非另有规定，仲裁期间双方应当继续履行协议规定的义务。</div>
            <div class="things">2、如本协议的任何条款被视作无效或无法执行，其余部分则仍具有法律效力。</div>
            <div class="things">3、响锣店群针对用户过失或违约时放弃本协议规定的权利的，不得视为其对用户的其他或以后同类之过失或违约行为弃权。</div>
            <div class="things">4、本协议应取代双方此前就本协议任何事项达成的全部口头和书面协议、安排、谅解和通信。</div>
            <div class="things">5、响锣店群有权根据业务调整情况将本协议项下的全部权利义务一并转移给其关联公司，转让将以本协议规定的方式通知，用户承诺对此不持有异议。</div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>

export default {
  data () {
    return {
      sid: '',
      id: '',
      status: '',
      detail: {}
    }
  },
  created () {
    this.id = this.$route.query.id
    this.status = this.$route.query.status
    this.getDetail()
  },
  components: {

  },
  methods: {

  }
}
</script>
<style lang="less" scoped>
  .agreementPage{
      padding:  20px 15px 20px 15px;
  }
    body{
    font-family: 'Arial,Helvetica,sans-serif';
    padding: 0 10px;
    font-size:12px;
   line-height: 1.5em;
  }
   

  h2{
   font-size: 15px;
  }

  p{
  }
  .bold{
   font-weight: bold;
  }

.agreement {
    padding: 40rpx 37rpx 30rpx;
    max-width: 1000px;
    margin: 0 auto;
    
}
.title {
    font-size: 36rpx;
    color: #333;
    font-weight: bold;
    text-align: center;
    margin-bottom: 39rpx;
    }
    .content {
    font-size: 28rpx;
    color: #333;
    
    }
    .joins {
        margin-bottom: 30rpx;
        }
        .deno {
        margin: 20rpx 0rpx;
        }
        .name {
        margin-bottom: 20rpx;
        
        }

    .num {
            color: #333;
            font-weight: bold;
        }
        .things {
            margin-bottom: 30rpx;
        }
</style>
